<div
  class="fixed inset-0 z-[10000000000] h-full w-full select-none bg-neutral-low-pure/75 backdrop-blur-sm"
  data-cid="loader-overlay"
  aria-label="Carregando"
  [@fadeInOut]="isVisible"
  (@fadeInOut.done)="onAnimationDone($event)"
>
  <div class="flex h-full flex-col items-center justify-center">
    <img src="assets/images/logo-liv.webp" class="h-auto w-20 lg:w-24" />
    @if (message()) {
      <p class="mt-3 font-sans text-sm font-semibold text-neutral-low-dark">
        {{ message() }}
      </p>
    }
  </div>
</div>
